import './StaffModerationLayout.css'

import { NavLink, Outlet } from 'react-router'

import { PageHeader } from '../../../components/PageHeader'

export function StaffModerationLayout() {
  return (
    <div className="staff-moderation">
      <PageHeader title="Moderation" subtitle="Trust and safety tools for members and photos." />

      <nav className="staff-moderation__subnav" aria-label="Moderation sections">
        <NavLink
          to="/staff/moderation/users"
          className={({ isActive }) =>
            `staff-moderation__tab${isActive ? ' staff-moderation__tab--active' : ''}`
          }
        >
          Users
        </NavLink>
        <NavLink
          to="/staff/moderation/photos"
          className={({ isActive }) =>
            `staff-moderation__tab${isActive ? ' staff-moderation__tab--active' : ''}`
          }
        >
          Photos
        </NavLink>
        <NavLink
          to="/staff/moderation/reports"
          className={({ isActive }) =>
            `staff-moderation__tab${isActive ? ' staff-moderation__tab--active' : ''}`
          }
        >
          Reports
        </NavLink>
      </nav>

      <div className="staff-moderation__content">
        <Outlet />
      </div>
    </div>
  )
}
